// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3vy8T","aims":"styles_aims__UANZn","aim":"styles_aim__8fQW_","checkIconWrapper":"styles_checkIconWrapper__Qd3Lx","aimText":"styles_aimText__6kTrK"};